import { useNavigate } from 'react-router-dom';
import { Alert, Button, Stack, Typography } from '@mui/material';

export default function PlanInactiveBanner() {
  const navigate = useNavigate();

  return (
    <Alert
      severity="warning"
      sx={{
        borderRadius: 0,
        mb: { xs: 4, md: 4 },
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'stretch', md: 'center' },
        gap: { xs: 1.5, md: 0 },
        py: { xs: 2, md: 1.25 },
        px: { xs: 2, md: 2 },
        '& .MuiAlert-icon': {
          alignSelf: { xs: 'flex-start', md: 'center' },
          marginRight: { xs: 0, md: 1.5 },
          padding: 0,
        },
        '& .MuiAlert-message': {
          padding: 0,
          width: { xs: '100%', md: 'auto' },
          flex: { md: '1 1 auto' },
          minWidth: 0,
        },
        '& .MuiAlert-action': {
          marginRight: 0,
          marginLeft: { xs: 0, md: 'auto' },
          paddingLeft: { xs: 0, md: 2 },
          paddingTop: { xs: 0.5, md: 0 },
          alignSelf: { xs: 'stretch', md: 'center' },
          width: { xs: '100%', md: 'auto' },
        },
      }}
      action={
        <Button
          color="inherit"
          size="medium"
          variant="outlined"
          onClick={() => navigate('/plans')}
          sx={{
            width: { xs: '100%', md: 'auto' },
            py: { xs: 1, md: 0.5 },
            px: { xs: 2, md: 1.5 },
            whiteSpace: { xs: 'normal', md: 'nowrap' },
            lineHeight: 1.3,
            textAlign: 'center',
          }}
        >
          Ver Planos e Ativar
        </Button>
      }
    >
      <Stack spacing={1}>
        <Typography variant="subtitle2" component="p" sx={{ m: 0, fontWeight: 600 }}>
          Sua conta está limitada ao recebimento de documentos para assinatura.
        </Typography>
        <Typography variant="body2" color="text.secondary" component="p" sx={{ m: 0 }}>
          Para enviar seus próprios documentos e gerenciar fluxos completos, escolha o plano ideal
          para você.
        </Typography>
      </Stack>
    </Alert>
  );
}
